import gql from 'graphql-tag'

const query = gql`query clinicDevices {
    clinicDevices {
        nodes {
            id
            isClinicDevice
            name
        }
    }
}
`
export default query
